import { createApp } from 'vue';
import App from './App.vue';
import 'virtual:wanli-approved-style.css';
import './styles/vue-shell.css';
import './styles/site-palette.css';
import './styles/game-palette.css';
import './styles/loading.css';
import './styles/typography-readability.css';

createApp(App).mount('#app');
